<template>
  <div class="myshipment">
    <div id="moduletitle">
      <h2>My Shipment</h2>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {};
</script>
<style>
</style>